var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("the-breadcrumb", { attrs: { state: _vm.state } }),
      _c(
        "w-container",
        [
          _c("the-properties", { attrs: { state: _vm.state } }),
          _c("the-table", { attrs: { state: _vm.state } }),
          _c("app-totals", {
            attrs: {
              "selected-row": _vm.state.selectedRow,
              totalable: _vm.state.sale,
              "toggle-profit": _vm.state.profitVisble,
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.state.saveModalOpen } },
        [
          _vm.state.saveModalOpen
            ? _c("the-save-modal", { attrs: { state: _vm.state } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }